<template>
  <pp-app>
    <div
      class="reputation-app"
      :class="{ 'reputation-app--narrow': isLocationStep }"
    >
      <router-view />
    </div>
  </pp-app>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLocationStep () {
      return this.$route.name === 'LocationSelection'
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: #fff;
  font-family: $font-family-base;
  margin: 0;
}

.reputation-app {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 800px;
  padding: 15px;
  width: 100%;

  &--narrow {
    max-width: 610px;
  }

  .body {
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    padding: 20px;
  }

  .eyebrow {
    border: none;
  }

  // Chrome paints autofilled fields with its own pale blue, and it only covers
  // the inner input rather than the whole text-field slot. The inset shadow is
  // the only way to repaint it, and tracking the library's fill variable keeps
  // the focused and error states correct.
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    box-shadow: inset 0 0 0 100px var(--pp-text-field-fill, #e9efee);
    caret-color: $text-primary;
    -webkit-text-fill-color: $text-primary;
  }

  // The library's secondary button is a transparent pill with a #d6d6d6 border,
  // which disappears on the grey private-feedback panel. Tint it with the
  // practice color the way the widget's old secondary button was.
  /* stylelint-disable-next-line selector-class-pattern -- library BEM class */
  .pp-button.pp-button--secondary {
    --pp-button-hover-bg: #f0f2f7;

    background: #fff;
    border-color: var(--color-primary, #555f7e);
    color: var(--pp-secondary-button-text-color, var(--color-primary, #555f7e));
  }
}
</style>
